export const bartRedYellowLine = [
    [37.59984516866034, -122.38646053662681],
    [37.61160432202427, -122.39819483130304],
    [37.613174889941746, -122.39960604414543],
    [37.61473742024317, -122.39951778308011],
    [37.61546418124923, -122.39857866085613],
    [37.615663424960964, -122.39414808104642],
    [37.61606484744051, -122.39219866201557],
    [37.6156839606112, -122.39751806687183],
    [37.615902078183936, -122.40060052117587],
    [37.61711912675849, -122.40263871369056],
    [37.62196069030832, -122.40642683349243],
    [37.6228804027517, -122.4071687716883],
    [37.6309829209442, -122.41187116103397],
    [37.63771061958851, -122.41628438926192], // BART San Bruno
    [37.64219519564601, -122.41880060888535],
    [37.64440645614295, -122.42050257552927],
    [37.64978835002898, -122.4252949931127],
    [37.650771616270106, -122.42617698687717],
    [37.65162114297728, -122.42727103535667],
    [37.65262972059843, -122.42878993872014],
    [37.653512703429186, -122.43032235480337],
    [37.65601328261467, -122.43472487829126],
    [37.65837678285317, -122.43732981306592],
    [37.6612601775812, -122.43976083886996],
    [37.66207419510715, -122.44064989348719],
    [37.66303718231401, -122.4421813632599],
    [37.6641342395769, -122.44391545127048], // BART South San Francisco
    [37.66676564983759, -122.44772902240659],
    [37.668037576544805, -122.4489718634524],
    [37.669079317971025, -122.44970698593144],
    [37.67323768937376, -122.45250542256042],
    [37.67429782454693, -122.45359720235413],
    [37.67497515537313, -122.4545364734205],
    [37.67595064651098, -122.45612013483883],
    [37.67756571878399, -122.45807328681505],
    [37.68080073927377, -122.46113351099514],
    [37.68204563798074, -122.4625089123331],
    [37.684585298483036, -122.46610664985039], // BART Colma
    [37.68565371090245, -122.46778150487425],
    [37.6892177300616, -122.46981163635417],
    [37.69098620776384, -122.46986722875253],
    [37.695009328837195, -122.46998105375302],
    [37.697593588002185, -122.47091905731921],
    [37.70293266405246, -122.47110750641498],
    [37.70375990994514, -122.47088336000951],
    [37.70624740031143, -122.46899897170641], // BART Daly City
    [37.70904638137617, -122.46658903824704],
    [37.70982500889729, -122.46541405487358],
    [37.71006652673833, -122.46435568104548],
    [37.71005522018419, -122.45858092032623],
    [37.710354024415636, -122.45626785589667],
    [37.711201395795094, -122.4543144569385],
    [37.71505354941722, -122.44970596242291],
    [37.71606322379549, -122.44883977493829],
    [37.71722583093106, -122.44829499968313],
    [37.7188234997677, -122.44809828588171],
    [37.721709393604435, -122.44741807119449], // BART Balboa Park
    [37.724770933344686, -122.44651683672616],
    [37.72562139749788, -122.4460052503194],
    [37.72673701746046, -122.44512518350886],
    [37.72786269779638, -122.44359555136066],
    [37.729843865478934, -122.43927576509009],
    [37.73323635322208, -122.43346012900454], // BART Glen Park
    [37.73941922130502, -122.42435119491823],
    [37.74020943934382, -122.42355429275635],
    [37.74124845000579, -122.422732720706],
    [37.748306312083756, -122.4181141151784],
    [37.75222289279655, -122.41852639240409], // BART 24th St Mission
    [37.765379907884466, -122.41979544923527], // BART 16th St Mission
    [37.772050311211096, -122.42038351464971],
    [37.773644051233745, -122.41993214464861],
    [37.77512369622189, -122.41910686579328],
    [37.77562084109104, -122.41873376331655],
    [37.77956379514448, -122.4137196092685], // BART Civic Center
    [37.7843490642855, -122.40804511030784], // BART Powell St
    [37.78939611430761, -122.40117601414059], // BART Montgomery St
    [37.79293856027791, -122.39702374502227], // BART Embarcadero
    [37.79899555598394, -122.38888877228342],
    [37.80014662395084, -122.38669630246413],
    [37.81012071631552, -122.34212660844065],
    [37.81058984891128, -122.33887426228112],
    [37.81026880444282, -122.33298396232539],
    [37.808975097070544, -122.31838213530663],
    [37.80790626888733, -122.30735480394326],
    [37.80774898818961, -122.30642642285595],
    [37.80597391907348, -122.29808654169192],
    [37.80482517793759, -122.2952694298787], // BART West Oakland
    [37.80312919895131, -122.2907879713957],
    [37.80269327027139, -122.28905489239243],
    [37.801647097918384, -122.28453910174318],
    [37.801111654076024, -122.28328335602775],
    [37.798636645865585, -122.27827086870796],
    [37.79857792842283, -122.27606786470474],
    [37.799274311022835, -122.27430852059047],
    [37.79955599050584, -122.27408553198853],
    [37.80345615057081, -122.27161724844689], // BART 12th St Oakland
    [37.80964288766491, -122.26779636346348],
    [37.81020507607589, -122.26771554506628], // BART 19th St Oakland (somewhere here)
    [37.81076311546558, -122.26793439571574], 
    [37.812910130519505, -122.2702246365638],
    [37.813762993521806, -122.27075552644777],
    [37.81495041470212, -122.2709476040355],
    [37.81559572400692, -122.27087417557674],
    [37.82877944557078, -122.26722124623498], // BART MacArthur
];